import { render, staticRenderFns } from "./Solicitudes_factoring.vue?vue&type=template&id=5ec4b7be&scoped=true&"
import script from "./Solicitudes_factoring.vue?vue&type=script&lang=ts&"
export * from "./Solicitudes_factoring.vue?vue&type=script&lang=ts&"
import style0 from "./Solicitudes_factoring.vue?vue&type=style&index=0&id=5ec4b7be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec4b7be",
  null
  
)

export default component.exports